<div class="ui-msg-block">
  <!-- 0 temp for demo modal -->
  <template v-if="state.type == POPUP.DEMO">
    <Modal content="" v-model:isOpen="state.isOpenModal" titleH="md" contentTDSpace="none" alignBtn="center"
      @onClickCancel="cancelTestModal" @onClickConfirm="sumbitTestModal(state.testName)" :btnConfirm="
      {
        text: '確認',
        disable: false,
        theme: '1',
        color: 'main',
        type: 'full',
        wd: 'md'
      }" :btnCancel="{
      text: '取消',
      disable: false,
      theme: '1',
      color: 'main',
      type: 'border',
      wd: 'md'
    }">
      <ul>
        <li v-for="(item, index) in state.data">{{index}} - {{item}}</li>
      </ul>
      <input type="text" v-model="state.testName">
      <p class="textWhite">test name: {{state.testName}}</p>
    </Modal>
  </template>
  <!-- API ERROR POPUP -->
  <template v-if="(state.type).indexOf(POPUP.APIERROR) != -1">
    <Modal content="" :title="t('__main.__error')" v-model:isOpen="state.isOpenModal" titleH="md" contentTDSpace="none"
      alignBtn="right" :btnConfirm="
        {}" :btnCancel="btnDefault(t('__common.__ok'))">
      <div class="modal-content-detail style--normal-text">
        <p class="colosr--main">{{state.data}}</p>
      </div>
    </Modal>
  </template>
  <!-- privacy notice -->
    <Modal  v-if="(state.type).indexOf(POPUP.PRIVACY) != -1" class="modal-license" wd="lg" alignTitle="center" :title="t('__main.__asusPrivacyNotice')" content=""
      v-model:isOpen="state.isOpenModal" :btnConfirm="btnMainStyleEnable(t('__common.__agree'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__disagree'))" @onClickCancel="onPrivacySumbit(false)"
      @onClickConfirm="onPrivacySumbit(true)" :isHasClose="false" alignBtn="center" contentSpace="md">
      <div class="modal-content-detail style--text">
        <p class="color--main font--weight-bold">{{__popup.__asusPrivacyNoticeTitle}}</p>
        <p class="space--sm">{{__popup.__asusPrivacyNoticeTitleDesc1}}</p>
        <p class="space--sm">{{__popup.__asusPrivacyNoticeTitleDesc2}}</p>

        <div class="space-out-top-base-12">
          <p class="space--sm font--weight-bold">{{__popup.__asusPrivacyNoticePart1Title}}</p>
          <ol class="list-style-num list-block has--space">
            <li>
              <p>{{__popup.__asusPrivacyNoticePoint1_text}}</p>
              <p class="space--sm">{{__popup.__asusPrivacyNoticePoint1_data}}</p>
              <p class="space--sm">{{__popup.__asusPrivacyNoticePoint1_note}}</p>
            </li>
            <li>
              <p>{{__popup.__asusPrivacyNoticePoint2_text}}</p>
            </li>
            <li>
              <p class="font--weight-bold">{{__popup.__asusPrivacyNoticePoint3_title}}</p>
              <p>{{__popup.__asusPrivacyNoticePoint3_text}}</p>
            </li>
            <li>
              <p>{{__popup.__asusPrivacyNoticePoint4_text}}
              <a class="link--sub" target="__blank"
                :href="privacyLink">{{__popup.__asusPrivacyNoticePoint4_link}}</a>
              </p>
            </li>
          </ol>
        </div>


        <div class="space-out-top-base-12" v-if="__popup.__asusEUDataActNoticePart2Title">
          <p class="space--sm font--weight-bold">{{__popup.__asusEUDataActNoticePart2Title}}</p>
          <p>{{__popup.__asusEUDataActNoticeIntro}}</p>
          <ol class="list-style-num list-block has--space">
            <li>
              <p>{{__popup.__asusEUDataActNoticePoint1_title}}</p>
              <ul class="list-style-none has--space-sm">
                <li>{{__popup.__asusEUDataActNoticePoint1_1}}</li>
                <li>{{__popup.__asusEUDataActNoticePoint1_2}}</li>
                <li>{{__popup.__asusEUDataActNoticePoint1_3}}</li>
              </ul>
            </li>
            <li>
              <p>{{__popup.__asusEUDataActNoticePoint2_title}}</p>
            </li>
            <li>
              <p>{{__popup.__asusEUDataActNoticePoint3_title}}</p>
               <ul class="list-style-none has--space-sm">
                <li>{{__popup.__asusEUDataActNoticePoint3_1}}</li>
                <li>{{__popup.__asusEUDataActNoticePoint3_2}}</li>
              </ul>
            </li>
            <li>
              <p>{{__popup.__asusEUDataActNoticePoint4_title}}</p>
               <ul class="list-style-none has--space-sm">
                <li>{{__popup.__asusEUDataActNoticePoint4_1_pre}}<a class="link--sub" target="__blank" href="https://privacy.asus.com/pi/global/privacy">{{__popup.__asusEUDataActNoticePoint4_1_link_text}}</a>{{__popup.__asusEUDataActNoticePoint4_1_post}}</li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </Modal>
  <!-- end of privacty notice -->

  <!-- privacy notice  state.type == POPUP.AGREEMENT-->
  <template v-if="(state.type).indexOf(POPUP.AGREEMENT) != -1">
    <Modal class="modal-eula" wd="lg" alignTitle="center" :title="__popup.__EULA.title" content=""
      v-model:isOpen="state.isOpenModal" :btnConfirm="btnMainStyleEnable(t('__common.__agree'))" :btnCancel="{}"
      :isHasClose="false" alignBtn="center" contentSpace="md" @onClickConfirm="onEULAubmit">
      <div class="modal-content-detail style--text">
        <div v-html="__popup.__EULA.content"></div>
        


      </div> 
    </Modal>
  </template>
  <!-- end of privacty notice -->

  <!-- contact us -->
  <template v-else-if="state.type == POPUP.CONTACT">
    <Modal class="modal-contact" :isConfirmClose="false" contentSpace="md" wd="lg" content="" :isHasConfirm="true"
      :title="t('__main.__contactAsus')" v-model:isOpen="state.isOpenModal" :btnCancel="{}" :isHasClose="true"
      :btnConfirm="btnMainStyleEnable(t('__common.__send'), contactModal.btnDisable)" @onClickCancel="cleanContactForm"
      @onClickConfirm="submitContactus" alignBtn="right">
      <div class="modal-content-detail">
        <div class="ui-form-layout" ref="contactForm">
          <ul class="">
            <li class="ui-form-grid-row">
              <div class="ui-form-grid-col-12">
                <div class="form-title-block">
                  <div class="form-title form-required">{{t('__main.__mailAddress')}}</div>
                </div>
                <div class="form-item-block">
                  <Input name="mail" v-model:value="contactModal.mail" bg="unset" placeholder=""
                    :isError="contactModal.isMailError"></Input>
                  <div class="form-error-block" v-if="contactModal.isMailError">
                    <p class="error-txt">*{{t('__main.__requiredForms')}}</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="ui-form-grid-row">
              <div class="ui-form-grid-col-12">
                <div class="form-title-block">
                  <div class="form-title form-required">{{t('__main.__country')}} / {{t('__main.__region')}}</div>
                </div>
                <div class="form-item-block">
                  <Input name="region" v-model:value="contactModal.region" bg="unset" placeholder=""
                    :isError="contactModal.isRegionError"></Input>
                  <div class="form-error-block" v-if="contactModal.isRegionError">
                    <p class="error-txt">*{{t('__main.__requiredForms')}}</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="ui-form-grid-row">
              <div class="ui-form-grid-col-12">
                <div class="form-title-block">
                  <div class="form-title form-required">{{t('__main.__yourQuestion')}}</div>
                </div>
                <div class="form-item-block">
                  <Textarea name="msg" v-model:value="contactModal.msg" bg="unset" placeholder=""
                    :isError="contactModal.isMsgError" :isDisable="false"></Textarea>
                  <div class="form-error-block" v-if="contactModal.isMsgError">
                    <p class="error-txt">*{{t('__main.__requiredForms')}}</p>
                  </div>
                </div>
              </div>
            </li>

          </ul>
          <div class="checkbox-block">
            <Checkbox :isSlot="true" :isFlex="true" v-model:isCheck="contactModal.isCheck">
              <p>
                {{t('__main.__iAgreeToProvideTheAboveInformation')}} <a
                  href="https://www.asus.com/Terms_of_Use_Notice_Privacy_Policy/Privacy_Policy/" target="_blank"
                  class="link--sub">{{t('__main.__asusPrivacyPolicy')}}</a>
              </p>
            </Checkbox>
            <div class="form-error-block align-left" v-if="contactModal.isCheckError">
              <p class="error-txt">*{{t('__main.__requiredForms')}}</p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </template>

  <!-- end of contact us -->

  <!-- side add device -->
  <template v-else-if="state.type == POPUP.GLOBALADDDEVICE">
    <Modal class="modal-global-add-device" btnArrange="top-down" wd="sm" :title="t('__d7d_n17r.__addDevice')"
      :isHasConfirm="true" content="" v-model:isOpen="state.isOpenModal" :btnConfirm="{}" :btnCancel="{}"
      :isHasClose="true" @onClickCancel="closeGlobalAddDevice">
      <div class="modal-content-detail">
        <div class="tab-title-list">
          <Tab theme="2" wd="auto" :tabText="globalAddDeviceModal.tabText" @onClick="onClickGlobalDeviceTab">
          </Tab>
        </div>
        <div class="tab-content-block space-modal-md">
          <!-- tab1 -->
          <div class="tab-content-detail tab1" v-show="globalAddDeviceModal.activeTabIndex === 0">
            <div class="img-block">
              <img :src="require('@/assets/images/popup-img-upload.png')">
            </div>
            <div class="text-block">
              <p class="desc">{{t('__main.__uploadAStandardCsvFileWithMultiDeviceInformation')}}</p>
            </div>
            <!-- btn -->
            <div class="btn-block space-out-bottom-base-4">
              <input type="file" ref="csvUploadBtn" class="hidden" accept=".csv, text/csv"
                @change="uploadCSVFile($event)">
              <Button id="GTM__uploadCsv" type="full" class="btn-single" colors="main-gradient" :text="t('__popup.__uploadCsv')" wd="full"
                @onClick="uploadCSV"></Button>
              <Button id="GTM__downloadSample" type="border" class="btn-single" colors="main" :text="t('__main.__downloadSample')" wd="full"
                @onClick="onClickDownloadCSV"></Button>
            </div>
          </div>
          <!-- tab2 -->
          <div class="tab-content-detail tab2" v-show="globalAddDeviceModal.activeTabIndex === 1">
            <template v-if="!globalAddDeviceModal.isShowCode">
              <div class="img-block">
                <img :src="require('@/assets/images/popup-img-upload.png')">
              </div>
            </template>
            <!-- code -->
            <template v-else>
              <div class="main-desc-block">
                <div class="desc-lg">{{globalAddDeviceModal.code}}</div>
                <p class="desc--sm">
                  <span class="txt">{{t('__popup.__timeRemaining')}}</span>
                  <Timer class="timer" v-model:isStart="globalAddDeviceModal.isStart" :time="globalAddDeviceModal.time"
                    @finish="finshTimer"></Timer>
                </p>
                <div class="desc-copy">
                  <!-- 0705 -->
                  <Button class="btn" wd="md" colors="main" :text="t('__popup.__copyCode')" type="border"
                    icon="icon-paste" @onClick="copyInviteCode"></Button>
                </div>
              </div>
            </template>
            <div class="text-block">
              <p class="desc">{{t('__main.__provideTheInvitationCodeTheComputer')}}
                “{{t('__main.__pACCApplicationCloudManagement', {brand: brand})}}”.</p>
            </div>
            <!-- end of code -->
            <div class="btn-block space-out-bottom-base-4">
              <Button id="GTM__generateBindingCode" type="full" class="btn-single" colors="main-gradient" :text="t('__main.__generateBindingCode')"
                wd="full" @onClick="generateCode" icon="icon-refresh"
                :disable="globalAddDeviceModal.btnGenerateDisable"></Button>
              <!-- :disable="globalAddDeviceModal.btnCodeDisable" 修正可以重複生產code -->
            </div>
          </div>
        </div>
        <!-- end of tab-content-block -->

      </div>
    </Modal>
  </template>

  <!-- end of side add device -->

  <!-- import csv -->
  <template v-else-if="state.type == POPUP.IMPORTCSV">
    <Modal class="modal-import-csv" minH="md" content="" btnArrange="reverse" v-model:isOpen="state.isOpenModal"
      alignTitle="center" alignBtn="center" :title="t('__main.__addDevicesViaCsv')" @onClickCancel="callBackAddDevice"
      wd="lg"
      :btnConfirm="importCVSModal.isErrorLength ? {} : btnMainStyleEnable(`${t('__common.__add')}(${csvCheckTotal})`, csvCheckTotal == 0)"
      @onClickConfirm="onSubmitCSVDeviceAdd" :btnCancel="btnBorderMainStyleEnable(isCSVBtnCancel())"
      :isVerify="importCVSModal.isErrorLength ? 'More than 20 error messages, please reconfirm and upload again' : ''">
      <div class="modal-content-detail">
        <!-- <p>defaultCheckIndexList: {{importCVSModal.defaultCheckIndexList}}</p> -->
        <div class="temp-select-block ui-grid-row space-in-left-base-6 space-in-right-base-6 space-in-bottom-base-5">
          <Select class="select-inline " :options="importCVSModal.optionsFilter"
            v-model:selected="importCVSModal.selectedFilter" @onChange="onChangeFilter"></Select>
        </div>
        <div class="table">
          <Table class="table-list-block" :defaultCheck="importCVSModal.defaultCheckIndexList"
            :disableCheck="importCVSModal.disableCheckList" @tableSort="sortCSVData" @onCheckAll="onCheckAllCSV"
            @showCTAndRow="showCTAndRowDevi" @onCheckEach="onCheckEachCSVData" @goTableLink="goTableLinkDevi"
            :columns="importCVSModal_columns" :data="importCVSModal.data" tablePadding="20" :checkBox="true">
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
            </template>
          </Table>
        </div>
      </div>
    </Modal>
  </template>
  <!-- More than 20 error messages, please reconfirm and upload again -->

  <!-- Exceed csv  //New Group-->
  <template v-else-if="(state.type).indexOf(POPUP.EXCEED) != -1">
    <Modal class="groupModal" content="" btnArrange="reverse" v-model:isOpen="state.isOpenModal"
      title="Exceed Upload Limitation" @onClickCancel="closeModal"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__confirm'))" :btnConfirm="{}">
      <div :class="[POPUP.DEVICEMODELERROR]" class="textLeft textWhite">
        {{t('__popup.__theUploadLimit',{num : '300'})}}
      </div>
    </Modal>
  </template>
  <!-- end of Exceed csv -->


  <!-- license -->
  <template v-else-if="(state.type).indexOf(POPUP.LICENSE) != -1">
    <Modal class="modal-license" btnArrange="top-down" wd="lg" alignTitle="center"
      :title="t('__main.__openSourceLicense')" content="" v-model:isOpen="state.isOpenModal"
      @onClickCancel="onCloseLicense" :btnConfirm="{}" :btnCancel="{}" :isHasClose="true" contentSpace="none"
      contentTDSpace="none">
      <div class="modal-content-detail space-out-bottom-base-12">
        <div class="tab-title-list">
          <Tab theme="2" class="tab-item" wd="auto" :tabText="licenseModal.tabText" @onClick="onClickLicenseTab">
          </Tab>
        </div>
        <div class="tab-content-block ">
          <!-- tab1 -->
          <div class="tab-content-detail space-out-top-base-12 tab1" v-show="licenseModal.activeTabIndex === 0">
            <Table :checkBox="false" :columns="licenseModal_columns" :data="webLicense" @goTableLink="golicenseLink">
              <template #empty="{text}">
                <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
              </template>
            </Table>
          </div>
          <!-- tab2 -->
          <div class="tab-content-detail space-out-top-base-12 tab2" v-show="licenseModal.activeTabIndex === 1">
            <div class="table">
              <Table :checkBox="false" :columns="licenseModal_columns" :data="pcLicense" @goTableLink="golicenseLink">
                <template #empty="{text}">
                  <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
                </template>
              </Table>
            </div>
            <div class="table">
            </div>
          </div>
        </div>
        <!-- end of tab-content-block -->
      </div>
    </Modal>
  </template>
  <!-- end of license -->



  <!-- noraml modal -->
  <template v-else-if="state.type == POPUP.NORMAL">
    <Modal content="" v-model:isOpen="state.isOpenModal">
      <p>this is global message</p>
    </Modal>
  </template>



  <!-- group start -->
  <!-- ADD modal -->
  <template v-else-if="state.type == POPUP.GROUPADD">
    <Modal content="" v-model:isOpen="state.isOpenModal" class="groupModal" subTitle="" btnArrange="reverse"
      :btnConfirm="btnMainStyleEnable(t('__popup.__create'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))" @onClickCancel="groupNameClose"
      :title="t('__g3p_m8t.__newGroup')" @onClickConfirm="subGroupAdd(groupVal.groupName)" :isConfirmClose="false">
      <div :class="[POPUP.GROUPADD]">
        <div class="textWhite textLeft title">{{t('__g3p_m8t.__nameThisGroup')}}</div>
        <Input name="region" v-model:value="groupVal.groupName" bg="unset"
          :placeholder="`${t('__g3p_m8t.__newGroup')} ${state.data.totalLength+1}`" :isError="state.isGroupNameError"
          class="input"></Input>
        <div class="textRight error alertStyle">
          <span v-if="groupVal.isGroupNameError">{{groupVal.isGroupNameError}}</span>
        </div>
      </div>

    </Modal>
  </template>


  <!-- unGroup modal -->
  <template v-else-if="state.type == POPUP.UNGROUP">
    <Modal content="" :title="t('__g3p_m8t.__ungroupOnly')" class="groupModal" v-model:isOpen="state.isOpenModal"
      btnArrange="reverse" @onClickCancel="closeModal" @onClickConfirm="unGroup()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))">
      <div :class="[POPUP.UNGROUP]" class="textLeft textWhite">{{t('__g3p_m8t.__areYouSureYouWantToDisbandTheGroup')}}
      </div>
    </Modal>
  </template>

  <!-- unGroup and unBind modal -->
  <template v-else-if="state.type == POPUP.UNBIND">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal"
      :title="t('__g3p_m8t.__ungroupAndUnbindDevices')" btnArrange="reverse" @onClickCancel="closeModal"
      @onClickConfirm="unGroup()" :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))">
      <div :class="[POPUP.UNBIND]" class="textLeft textWhite">
        <div>{{t('__g3p_m8t.__areYouSureYouWantToDisbandAndUnbind')}}</div>
        <!-- <div>{{state.data.list}}</div> -->
        <div>
          <ul>
            <li>{{t('__D4E-407-M8T.__dataOfTheseDeviceWouldNoLongerBeAccessed')}}</li>
            <!-- <li v-for="list in state.data.list">{{list.model}}</li> -->
          </ul>
        </div>
      </div>
    </Modal>
  </template>

  <!-- device add modal -->
  <template v-else-if="state.type == POPUP.DEVICEDETAIL">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal" alignTitle="center" btnArrange="reverse"
      :title="t('__g3p_m8t.__addDeviceToTheGroup')" :subTitle="t('__g3p_m8t.__mustBeTheSameModel')" wd="lg"
      @onClickCancel="closeModal" @onClickConfirm="addDeviceToGroup()"
      :btnConfirm="btnMainStyleEnable(groupVal.addDeviceBtnText,!groupVal.selectList.length)"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))" alignBtn="center">
      <div class="modal_groupdevice" :class="[POPUP.DEVICEDETAIL]">
        <!-- <div>{{groupVal.selectList.length}}</div> -->
        <div class="select">
          <Select :options="state.data.selectModel" :isDisable="state.data.selectDisable" @onChange="selectChange"
            v-model:selected="groupVal.selectVal1" class="selectEach"></Select>
          <Select :options="state.data.selectStatus" @onChange="selectChange" v-model:selected="groupVal.selectVal2"
            class="selectEach"></Select>
        </div>
        <div class="table">
          <Table @tableSort="tableSortDeviceAdd" @onCheckAll="onCheckAllDevi" :columns="state.data['col']"
            @onCheckEach="onCheckEachDevi" :data="state.data['list']" tablePadding="20" :checkBox="true"
            :tableScrollHeight="modalTableScrollHeight">
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
            </template>
          </Table>
        </div>
      </div>
    </Modal>
  </template>


  <!-- device model error modal -->
  <template v-else-if="state.type == POPUP.DEVICEMODELERROR">
    <Modal content="" :title="t('__c3r_c9n.__deviceModelError')" class="groupModal" v-model:isOpen="state.isOpenModal"
      @onClickConfirm="groupError()" :btnCancel="{}" :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))">
      <div :class="[POPUP.DEVICEMODELERROR]" class="textLeft textWhite">
        {{t('__c3r_c9n.__theDisplaysThatAreCalibratedTogether')}}</div>
    </Modal>
  </template>



  <!-- Exceed the upper limit modal -->
  <template v-else-if="state.type == POPUP.OVERFLOW">
    <Modal content="" :title="t('__c3r_c9n.__exceedTheUpperLimit')" class="groupModal"
      v-model:isOpen="state.isOpenModal" @onClickConfirm="closeModal()" :btnCancel="{}"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))">
      <div :class="[POPUP.DEVICEUNBIND]" class="textLeft textWhite">
        <div>{{t('__c3r_c9n.__theMaximumNumberOfColorCalibration')}}</div>
        <div>
          <ul>
            <li v-for="list in state.data.list"> - {{list}} </li>
          </ul>
        </div>
      </div>
    </Modal>
  </template>




  <!-- Implementation  modal -->
  <template v-else-if="state.type == POPUP.IMPLEMENTATION">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal" alignTitle="left"
      :title="state.data.group_name" :subTitle="state.data.profile_name" @onClickCancel="closeModal" :isHasClose="true"
      wd="lg" :btnCancel="{}" :btnConfirm="{}">
      <div class="modal_groupdevice">
        <div class="table">
          <!-- @onCheckAll="onCheckAllDevi" @showCTAndRow="showCTAndRowDevi" 
            @onCheckEach="onCheckEachDevi" @goTableLink="goTableLinkDevi" -->
          <Table @tableSort="tableSortDevi" :columns="state.data.col" :data="state.data.list" tablePadding="20"
          :tableScrollHeight="modalTableScrollHeight">
            <template #custom="{data, row,index,title,text}">
              <div v-if="data.depiction_code || data.depiction_code == 0">{{t(title[text])}} [{{data.depiction_code}}]
                {{transferDepictionCodeForMessage(ERRORDESC,data.depiction_code)}}</div>
              <div v-if="data.depiction_code == null">{{t(title[text])}} [code] {{t('__main.__error')}}</div>
            </template>
            <template #reportth="{index,title}">
              <span>{{title}}</span>
            </template>
            <template #report="{index, data, text}">
              <span class="editIcon" @click="editApp(text,data)"
              @keypress.enter="editApp(text,data)" :tabindex="(!text || data.deleted) ? -1 : 0">
                <iCon iconClass="asus_proart_sw_ico_file_text" :class="{'noEdit': !text || data.deleted}"></iCon>
              </span>
            </template>
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
            </template>
          </Table>
        </div>

      </div>

    </Modal>
  </template>

  <!-- modify name modal  // tbd-->
  <template v-else-if="state.type == POPUP.MODIFYGROUP">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal" :title="t('__g3p_m8t.__modifyGroupName')"
      btnArrange="reverse" :btnConfirm="btnMainStyleEnable(t('__common.__save'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))" @onClickCancel="groupNameClose"
      @onClickConfirm="subGroupAdd(groupVal.groupName)" :isConfirmClose="false">
      <div :class="[POPUP.MODIFYGROUP]">
        <div class="textWhite textLeft title">{{t('__g3p_m8t.__nameThisGroup')}}</div>
        <Input name="region" v-model:value="groupVal.groupName" bg="unset" :placeholder="`${state.data.groupName}`"
          :isError="state.isGroupNameError? true : false" class="input"></Input>
        <div class="textRight error alertStyle">
          <span v-if="groupVal.isGroupNameError">{{groupVal.isGroupNameError}}</span>
        </div>
      </div>
    </Modal>
  </template>
  <!-- group end -->

  <!-- device start -->
  <!-- unbind  modal  -->
  <template v-else-if="state.type == POPUP.DEVICEUNBIND">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal" btnArrange="reverse"
      :title="t('__d4e_m8t.__unbindConfirmation')" @onClickCancel="closeModal" @onClickConfirm="unGroup()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))">
      <div :class="[POPUP.DEVICEUNBIND]" class="textLeft textWhite">
        <div>{{t('__d4e_m8t.__areYouSureToUnbindTheseMonitor')}} </div>
        <div>{{t('__d4e_m8t.__noticeOnceUnbindingAlert')}}</div>
        <div>
          <ul>
            <li v-for="list in state.data.list"> - {{list.model}}_{{list.host}} </li>
          </ul>
        </div>
      </div>
    </Modal>
  </template>


  <!-- table filter modal -->
  <template v-else-if="state.type == POPUP.DEVICETABLEFILTER">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal" btnArrange="reverse"
      :title="t('__popup.__tableItemFiliter')" @onClickCancel="closeModal" @onClickConfirm="tableFilter()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))">
      <div :class="[POPUP.DEVICERSET]" class="textLeft textWhite">
        <!-- <div>{{state.data.list}}</div> -->
        <a href=""></a> 
        <!-- add for ada redirect -->
        <div v-for="(e, i) in state.data.list">
          <Checkbox size="lg" :isFlex="true" v-model:isCheck="e.val" :text="e.title" :isDisable="e.disabled"
          ></Checkbox>
        </div>
      </div>
    </Modal>
  </template>
  <!-- table filter modal  -->


  <!-- device_reset  modal  -->
  <template v-else-if="state.type == POPUP.DEVICERSET">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal" :title="t('__d4e_m8t.__resetToDefault')"
      btnArrange="reverse" @onClickCancel="closeModal" @onClickConfirm="resetProfile()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))">
      <div :class="[POPUP.DEVICERSET]" class="textLeft textWhite">
        <a href=""></a> 
        <!-- add for ada redirect -->
        <div>{{t('__d4e_m8t.__chooseWhichOsdPresetMode')}}</div>
        <div v-for="(e, i) in state.data.list">
          <Checkbox size="lg" :isFlex="true" v-model:isCheck="e.val" :text="e.title"></Checkbox>
        </div>
      </div>
    </Modal>
  </template>

  <!-- notification  modal  -->
  <template v-else-if="state.type == POPUP.DEVICENOTIFICATION">
    <Modal content="" class="groupModal" v-model:isOpen="state.isOpenModal" :title="t('__d4e_m8t.__notification')"
      @onClickCancel="closeModal" :btnConfirm="{}" :btnCancel="btnMainStyleEnable(t('__common.__cancel'))">
      <div :class="[POPUP.DEVICENOTIFICATION]" class="textLeft textWhite">
        {{t('__d4e_m8t.__pleaseConfirmTheConnectionStatus')}}</div>
    </Modal>
  </template>




  <!-- device end -->

  <!-- Dashboard start -->
  <template v-if="state.type == POPUP.DETAILS">
    <Modal minH="md" :title="state.data.group_name ? state.data.group_name + ' / ' : ' ' + state.data.profile_name"
      content="" v-model:isOpen="state.isOpenModal" alignBtn="center" @onClickCancel="cancelTestModal"
      @onClickConfirm="sumbitTestModal(state.testName000000)" wd="lg" :isHasClose="state.istrue" contentTDSpace="none"
      :btnConfirm="
      {
      }" :btnCancel="{
    }">
      <Table class="textWhite" @tableSort="tableSortDashboard" @onCheckAll="onCheckAll" @showCTAndRow="showCTAndRow"
        @onCheckEach="onCheckEach" @goTableLink="goDashboardTaskLink" :columns="state.data.deviceListCol"
        :data="state.data.deviceListData" tablePadding="20">
        <template #custom="{data, row,index,title,text}">
          <div v-if="data.depiction_code || data.depiction_code == 0">{{t(title[text])}} [{{data.depiction_code}}]
            {{transferDepictionCodeForMessage(ERRORDESC,data.depiction_code)}}</div>
          <div v-if="data.depiction_code == null">{{t(title[text])}} [code] {{t('__main.__error')}}</div>
        </template>
        <template #report="{index, data, text}">
          <span class="editIcon" @click="Detial_icon(data)"
          @keypress.enter="Detial_icon(data)" :tabindex=" !text ? -1 : 0">
            <iCon iconClass="asus_proart_sw_ico_file_text" :class="{'noEdit': !text}"></iCon>
          </span>
        </template>
        <template #empty="{text}">
          <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
        </template>
      </Table>
    </Modal>
  </template>
  <!-- Dashboard end -->
  <!-- Calibration start -->

  <!-- go other page  -->
  <template v-else-if="state.type == POPUP.LEAVEADVANCED">
    <Modal content="" :title="t('__popup.__notices')" class="groupModal" v-model:isOpen="state.isOpenModal"
      btnArrange="reverse" :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))"
      @onClickConfirm="leaveAdvanced()" @onClickCancel="closeModal()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))">
      <div :class="[POPUP.UNBIND]" class="textLeft textWhite">
        {{state.data.isAdvanced ? t('__popup.__endCalibrationProcess') : t('__popup.__cancelModifyAppointment')}}?
      </div>
    </Modal>
  </template>


  <template v-if="state.type == POPUP.CUSTOMIZED">
    <Modal content="" v-model:isOpen="state.isOpenModal" alignTitle="center"
      :title="t('__c3r_c9n.__selectDevicesOrGroup')" :subTitle="t('__g3p_m8t.__mustBeTheSameModel')" class="groupModal"
      @onClickConfirm="send_customized" btnArrange="reverse" :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))"
      alignBtn="center" :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))" @onClickCancel="close_customized"
      wd="lg" :minH="'md'">
      <div class="modal_groupdevice textWhite">
        <div class="select">
          <Select :options="state.data.group_op" v-model:selected="calibration_data.group"
            class="selectEach displayInherit"></Select>
          <Select :options="state.data.device_op" v-model:selected="calibration_data.device"
            class="selectEach displayInherit"></Select>
        </div>
        <div class="table">
          <Table @tableSort="tableSortDevi" @onCheckAll="chose_devices_all" @showCTAndRow="showCTAndRowDevi"
            @onCheckEach="chose_devices" @goTableLink="goTableLinkDevi" :columns="state.data.col"
            :data="state.data.list" :defaultCheck="state.data.defaultCheck" tablePadding="20" :checkBox="true"
            :tableScrollHeight="modalTableScrollHeight">
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
            </template>
          </Table>
        </div>
      </div>
    </Modal>
  </template>


  <template v-if="state.type == POPUP.CUSTOMIZEDGROUP">
    <Modal content="" v-model:isOpen="state.isOpenModal" alignTitle="center"
      :title="t('__c3r_c9n.__selectGroup')" :subTitle="t('__g3p_m8t.__mustBeTheSameModel')" class="groupModal"
      @onClickConfirm="send_customized_group" btnArrange="reverse" :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))"
      alignBtn="center" :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))" @onClickCancel="close_customized_group"
      wd="lg" :minH="'md'">
      <div class="modal_groupdevice">
        <div class="table">
          <Table @tableSort="tableSortGroup" @onCheckAll="chose_groups_all"
            @onCheckEach="chose_group" :disableCheck="state.data.disableCheck" :columns="state.data.col"
            :data="state.data.list" :defaultCheck="state.data.defaultCheck" tablePadding="20" :checkBox="true"
            tableScrollHeight="340">
            <template #empty="{text}">
              <div class="Nodata">{{t('__d4e_m8t.__emptyPage')}}</div>
            </template>
          </Table>
        </div>
      </div>
    </Modal>
  </template>

  <template v-if="state.type == POPUP.SAVECUSTOMIZED">
    <Modal content="" v-model:isOpen="state.isOpenModal" titleH="md" contentTDSpace="none" alignBtn="right"
      :btnConfirm="btnDefault(t('__common.__save'),state.save_customized_name=='')"
      :btnCancel="btnDefault(t('__common.__skip'),false)" :title="t('__c3r_c9n.__saveCustomizedTarget')"
      btnArrange="reverse" @onClickCancel="skipCustomized" @onClickConfirm="saveCustomized" :isConfirmClose="false">
      <div class="save-customized-target">
        <p class="targetname">{{t('__c3d_t4t.__targetName')}}</p>
        <Input class="input" v-model:value="state.save_customized_name" :placeholder="'__a7d.__inputName'"></Input>
        <p v-if="state.data.nameError" class="error">{{t('__popup.__incorrectFormat')}} / {{t('__popup.__existedName')}}
        </p>
        <p v-else class="error"></p>
        <div class="info Gamut">
          <p class="title">{{t('__c3d_t4t.__colorGamut')}}</p>
          <!-- <div class="value" v-html="state.data.gamut"></div> -->
          <p class="value">{{state.data.gamut_text}}</p>
        </div>
        <div class="info" v-if="state.data.brightness">
          <p class="title">{{t('__d4e_m8t.__brightnessLmax')}}</p>
          <p class="value">{{state.data.brightness}} cd/m²</p>
        </div>
        <div class="info" v-if="state.data.brightness_min">
          <p class="title">{{t('__d4e_m8t.__brightnessLmin')}}</p>
          <p class="value">{{state.data.brightness_min}} cd/m²</p>
        </div>
        <div class="info" v-if="state.data.gamma">
          <p class="title">{{t('__c3d_t4t.__gamma')}}</p>
          <p class="value">{{state.data.gamma}}</p>
        </div>
        <div class="info" v-if="state.data.color_temperature">
          <p class="title">{{t('__d4e_m8t.__colorTemperature')}}</p>
          <p class="value">{{state.data.color_temperature}} k</p>
        </div>
      </div>
    </Modal>
  </template>

  <template v-if="state.type == POPUP.MODIFYSETTING">
    <Modal content="" v-model:isOpen="state.isOpenModal" titleH="md" wd="lg" contentTDSpace="none" alignBtn="center"
      @onClickCancel="cancelTestModal" @onClickConfirm="saveModifyData" title="" subTitle="" btnArrange="reverse"
      :btnConfirm="btnMainStyleEnable(t('__common.__modify'))"
      :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))">
      <div class="modify_setting">
        <div class="radio">
          <Radio class="input" v-model:selected="state.data.selectedVal" name="001" value="0"
            :text="t('__d4e_m8t.__presetMode', {brand: brand})" :isDisable=" !state.data['card'] || !state.data['card'].length">
          </Radio>
          <Radio class="input" v-model:selected="state.data.selectedVal" name="001" value="1"
            :text="t('__d4e_m8t.__userMode') + ' 1'">
          </Radio>
          <Radio class="input" v-model:selected="state.data.selectedVal" name="001" value="2"
            :text="t('__d4e_m8t.__userMode') + ' 2'">
          </Radio>
          <Radio v-if="state.data?.selectedVal == 3" class="input" 
            v-model:selected="state.data.selectedVal" name="001" value="3" :text="t('__d4e_m8t.__userMode') + ' 3'" 
            :isDisable="state.disable_all">
          </Radio>
        </div>
        <div v-if="state.data.selectedVal == '1'||state.data.selectedVal == '2' ||state.data.selectedVal == '3'">
          <div class="remind">{{t('__c3r_c9n.__theCalibrationResultWillOverwrite', {brand: brand})}}</div>
          <!-- <div>{{state.data.gamut}}</div>
          <div>{{state.data.target}}</div> -->
          <!-- <div>{{state.data.coordinateEnum}}</div> -->
          <div class="chose">
            <div class="outside mr37">
              <div class="title">{{t('__c3r_c9n.__applyTargetSettings')}}</div>
              <Select class="select" :options="state.data.target_op" v-model:selected="state.data.target"
                :isError="false" @onChange="onChangeTarget"></Select>
            </div>
          </div>

          <div class="chose">
            <div class="outside mr33">
              <div class="title">{{t('__c3d_t4t.__colorGamut')}}</div>
              <!-- <Select class="select" :options="state.gamut_op" v-model:selected="state.gamut" :isError="false" :isDisable="false"></Select> -->
              <Input class="input" v-model:value="state.data.gamut" placeholder=""
                v-if="!state.data.showGamutSelect"></Input>
              <Select class="select" v-model:selected="state.data.dicomGamut" @onChange="gamutOnChange"
                :options="state.data.dicomSelect_op" v-if="state.data.showGamutSelect" :isError="false"
                :isDisable="state.disable_all"></Select>
            </div>
            <div class="outside">
              <div class="title">{{t('__d4e_m8t.__eotf')}}</div>
              <Select class="select" :options="state.data.EOTF_op" v-model:selected="state.data.EOTF"
                @onChange="onChangeEotf" :isError="false"></Select>
            </div>

          </div>
          <div class="chose sliderBlock">
            <div class="outside">
              <!-- 0705 -->
              <div class="title">{{t('__c3r_c9n.__whitePoint')}}</div>
            </div>
          </div>


          <div class="radioBlock">
            <div class="flex">
              <Radio class="input" v-model:selected="state.data.whitePointSelect" name="003" value="colorTemperature"
                :text="t('__d4e_m8t.__colorTemperature')" :isDisable="state.disable_all "
                @onChange="onChangeModifyRadio"></Radio>
              <Slidebar class="sliderbar" size="small"
                :disable="state.data.disable_all || state.data.whitePointDisable == 1"
                v-if="state.data.temperature_data.length>0" 
                :startValue="state.data.temperature_start"
                :data="state.data.temperature_data" unit=" K" @onChange="temperature_change"
                :max="state.data.temperature_max" :min="state.data.temperature_min" :lock="state.data.temperature_lock"
                :isTemperature="true"></Slidebar>

            </div>
            <div class="flex">
              <Radio class="input" v-model:selected="state.data.whitePointSelect" name="003" value="coordinate"
                :text="t('__d4e_m8t.__coordinate')" :isDisable="state.data.disable_all" @onChange="onChangeModifyRadio">
              </Radio>
              <div>
                <span :class="{'disable':state.data.disable_all || state.data.whitePointDisable == 2}">x : </span>
                <Input @onChange="changeInt" class="select_ui coordinate-x" v-model:value="state.data.coordinate.x"
                  :minInt="state.data.coordinateEnum['x']['range_min']"
                  :maxInt="state.data.coordinateEnum['x']['range_max']" type="number"
                  :isDisable="state.data.disable_all || state.data.whitePointDisable == 2"></Input>
                <span :class="{'disable':state.data.disable_all || state.data.whitePointDisable == 2}">y : </span>
                <Input @onChange="changeInt" class="select_ui" v-model:value="state.data.coordinate.y"
                  :minInt="state.data.coordinateEnum['y']['range_min']"
                  :maxInt="state.data.coordinateEnum['y']['range_max']" type="number"
                  :isDisable="state.data.disable_all || state.data.whitePointDisable == 2"></Input>
              </div>
            </div>
          </div>


          <Slidebar class="sliderbar" size="small" v-if="state.data.brightness_max_data.length>0"
            :title="state.data.EOTF.text=='DICOM'? t('__d4e_m8t.__brightnessLmax'): t('__d4e_m8t.__brightnessLmax')"
            :startValue="state.data.brightness_max_start" :data="state.data.brightness_max_data" unit=" cd/m²"
            :right_fix="state.data.brightness_max_fix_right" @onChange="brightness_max_change"
            :max="state.data.brightness_max_max" :min="state.data.brightness_max_min" :max_value="state.data.bright_max"
            :min_value="state.data.bright_min"></Slidebar>
          <Slidebar class="sliderbar" size="small" v-if="state.data.brightness_min_data.length>0"
            :title="state.data.EOTF.text=='DICOM'? t('__d4e_m8t.__brightnessLmin') : t('__d4e_m8t.__brightnessLmin')"
            :startValue="state.data.brightness_min_start" :data="state.data.brightness_min_data" unit=" cd/m²"
            :right_fix="state.data.brightness_min_fix_right" @onChange="brightness_min_change"
            :max="state.data.brightness_min_max" :min="state.data.brightness_min_min" :max_value="state.data.bright_max"
            :min_value="state.data.bright_min" :dot="state.data.brightness_min_dot"></Slidebar>
          <Slidebar class="sliderbar" size="small" v-if="state.data.gamma_data.length>0" :title="t('__c3d_t4t.__gamma')"
            :startValue="state.data.gamma_start" :data="state.data.gamma_data" unit=""
            :right_fix="state.data.gamma_fix_right" @onChange="gamma_change" :dot="state.data.gamma_dot"></Slidebar>
        </div>
        <div v-if="state.data.selectedVal == '0'">
          <div class="remind">{{t('__popup.__presetModeWillBeCalibrated', { brand: brand })}}</div>
          <div class="remind">{{t('__popup.__ifYouWantToCustomize')}}</div>
          <div class="card">
            <Cardimg v-for="(item, index) in state.data.card" class="cardimg" :name="item.name"
              icon="asus_proart_sw_ico_color" :gamma="item.gamma" :color="item.color" :brightness="item.brightness"
              v-model:isCheck="item.click" size="large"></Cardimg>
          </div>
        </div>
      </div>
    </Modal>
  </template>
  <template v-if="state.type == POPUP.SAVEMODIFY">
    <Modal content="" v-model:isOpen="state.isOpenModal" class="groupModal" titleH="md" @onClickCancel="cancelTestModal"
      @onClickConfirm="sumbitTestModal(state.testName)" :title="t('__popup.__notices')">
      <div class="textLeft textWhite" :class="[POPUP.DEVICENOTIFICATION]">
        <p>{{t('__a7d.__someMonthsHaveLessThanDateDays',{ date : '29/30/31'})}}</p>
      </div>
    </Modal>
  </template>

  <!-- 0104 -->
  <template v-else-if="state.type == POPUP.PRESETLIMIT">
    <Modal content="" :title="t('__popup.__notices')" class="groupModal" v-model:isOpen="state.isOpenModal"
      btnArrange="reverse" :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))"
      @onClickConfirm="continueAdvanceBrightnessLimit()" @onClickCancel="closeModal()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))">
      <div :class="[POPUP.DEVICENOTIFICATION]" class="textLeft textWhite">
        <p>
          {{t('__popup.__thePresetHdrMode')}}
        </p>
        <br>
        <p>
          {{t('__popup.__ifYouChooseContinue')}}
        </p>
      </div>
    </Modal>
  </template>

  <!-- 0705 -->
  <template v-else-if="state.type == POPUP.BRIGHTLIMIT">
    <Modal content="" :title="t('__popup.__notices')" class="groupModal" v-model:isOpen="state.isOpenModal"
      btnArrange="reverse" :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))"
      @onClickConfirm="continueAdvanceBrightnessLimit()" @onClickCancel="closeModal()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))">
      <div :class="[POPUP.DEVICENOTIFICATION]" class="textLeft textWhite">
        {{t('__popup.__brightnessLimit')}}
      </div>
    </Modal>
  </template>

  <template v-else-if="state.type == POPUP.CLEARDEVICEANDGROUP">
    <Modal content="" :title="t('__popup.__notices')" class="groupModal" v-model:isOpen="state.isOpenModal"
      btnArrange="reverse" :btnCancel="btnBorderMainStyleEnable(t('__common.__cancel'))"
      @onClickConfirm="leaveAdvanced()" @onClickCancel="closeModal()"
      :btnConfirm="btnMainStyleEnable(t('__common.__confirm'))">
      <div :class="[POPUP.UNBIND]" class="textLeft textWhite">
        {{t('__c3r_c9n.__dividedGroupsAndDevices')}}
      </div>
    </Modal>
  </template>

  <!-- Calibration end -->
</div>